import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "login" */ './views/Login.vue'),
    },
    {
      path: '/demo',
      name: 'demo',
      component: () =>
        import(/* webpackChunkName: "demo" */ './views/Demo.vue'),
    },
    {
      path: '/consortia',
      name: 'consortia',
      component: () =>
        import(/* webpackChunkName: "consortia" */ './views/Consortia.vue'),
      meta: {
        Auth: true,
      },
    },
    {
      path: '/consortium/:id',
      name: 'consortium',
      component: () =>
        import(/* webpackChunkName: "consortium" */ './views/Consortium.vue'),
      meta: {
        Auth: true,
      },
    },
    {
      path: '/companies',
      name: 'companies',
      component: () =>
        import(/* webpackChunkName: "companies" */ './views/Companies.vue'),
      meta: {
        Auth: true,
      },
    },
    {
      path: '/company/:id',
      name: 'company',
      props: true,
      component: () =>
        import(/* webpackChunkName: "company" */ './views/Company.vue'),
      meta: {
        Auth: true,
      },
    },
    {
      path: '/employees',
      name: 'employees',
      component: () =>
        import(/* webpackChunkName: "employees" */ './views/Employees.vue'),
      meta: {
        Auth: true,
      },
    },
    {
      path: '/billing',
      name: 'billing',
      component: () =>
        import(/* webpackChunkName: "billing" */ './views/Billing.vue'),
      meta: {
        Auth: true,
      },
    },
    {
      path: '/settings',
      name: 'settings',
      props: true,
      component: () =>
        import(/* webpackChunkName: "settings" */ './views/Settings.vue'),
      meta: {
        Auth: true,
      },
    },
    {
      path: '*',
      name: 'dashboard',
      component: () => import('./views/DashBoard'),
      meta: {
        Auth: true,
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  // console.log('to', to)
  if (to.matched.some(record => record.meta.Auth)) {
    if (!store.state.isUserLoggedIn) {
      // console.log('test1')
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      })
    } else {
      // console.log('test2')
      next()
    }
  } else {
    // console.log('test3')
    next()
  }
})

export default router
